import * as React from 'react'

import { Props } from '../../containers/itemsBookmarsLoaderContainer'

interface IState {
  bookmarksLoaded: boolean
}

class ItemsBookmarksLoader extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props)
    this.state = {
      bookmarksLoaded: false
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const { userHasLoadAttempt, items, getBookmarksForItems } = this.props
    const { bookmarksLoaded } = this.state
    const newUserLoadAttempt =
      !prevProps.userHasLoadAttempt && userHasLoadAttempt

    if (!bookmarksLoaded && newUserLoadAttempt && items.length > 0) {
      getBookmarksForItems(items.map(item => item.id))
      this.setState({ bookmarksLoaded: true })
    }
  }

  public render() {
    const { children } = this.props
    return children
  }
}

export default ItemsBookmarksLoader
